// spread of levels allows others to be slipped in
export const OWNER = 100
export const EDITOR = 80
export const COMMENTER = 50
export const VIEWER = 10
export const NO_ACCESS = 0

// types
// TODO use these
// export const BOARD = 'board'
// export const FOLDER = 'folder'

// sidebar sections
export const BOARDS = 'boards'
export const FOLDERS = 'folders'
// sidebar filters
export const VIEWED = 'viewed'
export const CREATED = 'created'
export const MODIFIED = 'modified'
export const NAME = 'name'
export const UNFILED = 'unfiled'
export const MINE = 'mine'
export const SHARED = 'shared'
export const ARCHIVED = 'archived'
export const FILTERS = [MINE, SHARED, UNFILED, ARCHIVED]
